"use client"
import React, { useEffect, useState } from 'react';
import styles from "./style.module.css"
import forios from "../../../assets/images/forios.png"
import forandroid from "../../../assets/images/forandroid.png"
import outer from "../../../assets/images/outer.png"
import inner from "../../../assets/images/inner.png"
import guide from "../../../assets/images/guide.png"
// import { useTranslation } from 'react-i18next';

const InstallationGuide: React.FC = () => {
    // const { t } = useTranslation('common');
    const [selectedPlatform, setSelectedPlatform] = useState<string>("ios");
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);
  
    if (!isMounted) {
        return null;
      }

  return (
    <div className={`${styles.Installation_Guide}`}>
    <div className="container-fluid">
      <div className="row g-3 align-items-center">
        <div className="col-lg-6 col-md-12 ps-lg-4 pb-4">
          <div className={styles.left_section}>
            <h1 className="my-4">Installation Guide</h1>
           
            <div className={`${styles.buttons_group} bg-white`}>
              <button
                className={selectedPlatform === "ios" ? styles.active : ""}
                onClick={() => setSelectedPlatform("ios")}
              >
                <img className="me-2" src={forios} alt={"forios"} />
                FOR IOS
              </button>
              <button
                className={
                  selectedPlatform === "android" ? styles.active : ""
                }
                onClick={() => setSelectedPlatform("android")}
              >
                <img
                  className="me-2"
                  src={forandroid}
                  alt={"forandroid"}
                />
                FOR ANDROID
              </button>
            </div>
            <h5 className="my-4">
                  How to Install Commbitz eSIM in  
              <span className='ms-1'>{selectedPlatform === "ios" ? 'IOS' : 'ANDROID'} </span>?
            </h5>
            <div className="steps">
              <div
                className="step d-flex align-items-center mb-lg-4 mb-2"
                style={{ gap: "15px" }}
              >
                <div className={styles.step_number}>
                  <h6 className="mb-0">STEP</h6>
                  <h4 className="mb-0">01</h4>
                </div>
                <div className={styles.step_mobile}>
                  <h4 className="mb-0">Open Settings</h4>
                  <span>Open settings and look for Mobile Services</span>
                </div>
              </div>
              <div
                className="step d-flex align-items-center mb-lg-4 mb-2"
                style={{ gap: "15px" }}
              >
                <div className={styles.step_number}>
                  <h6 className="mb-0">STEP</h6>
                  <h4 className="mb-0">02</h4>
                </div>
                <div className={styles.step_mobile}>
                  <h4 className="mb-0">Go to Cellular</h4>
                  <span>In mobile Services see Add eSIM</span>
                </div>
              </div>
              <div
                className="step d-flex align-items-center mb-lg-4 mb-2"
                style={{ gap: "15px" }}
              >
                <div className={styles.step_number}>
                  <h6 className="mb-0">STEP</h6>
                  <h4 className="mb-0">03</h4>
                </div>
                <div className={styles.step_mobile}>
                  <h4 className="mb-0">Set Up Cellular</h4>
                      <span>In setup mobile service USE QR code</span>
                </div>
              </div>
              <div
                className="step d-flex align-items-center mb-lg-4 mb-2"
                style={{ gap: "15px" }}
              >
                <div className={styles.step_number}>
                  <h6 className="mb-0">STEP</h6>
                  <h4 className="mb-0">04</h4>
                </div>
                <div className={styles.step_mobile}>
                  <h4 className="mb-0">Open Photos</h4>
                  <span>Open photos and look scan QR code of the esim</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-12 align-self-end">
          <div className={styles.right_section}>
            <div className={styles.groupanimation}>
              <a
                href={
                  selectedPlatform === "ios"
                    ? "https://www.youtube.com/shorts/yJk3lSCnF2Y"
                    : "https://www.youtube.com/shorts/voW6qD5mQKE"
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className={styles.circleButton}>
                  <img
                    className={`${styles.outer} img-fluid`}
                    src={outer}
                    alt={"Rotating Ring"}
                  />
                  <img
                    className={styles.center}
                    src={inner}
                    alt={"Play Button"}
                  />
                </div>
              </a>
              <img
                className="img-fluid"
                style={{ width: "80%" }}
                src={guide}
                alt={"Guide"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default InstallationGuide;
